module.exports = __webpack_public_path__ + "static/media/IMG_1690.800303e4.JPG";